import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "sortAlphabet",
  standalone: true,
})
export class SortAlphabetPipe implements PipeTransform {
  public transform(array: Array<any>): Array<any> {
    let newArray = array;
    return newArray.slice().sort((a, b) => {
      if (a.descp < b.descp) {
        return -1;
      }
      if (a.descp > b.descp) {
        return 1;
      }
      return 0;
    });
  }
}
